import React from 'react';
import { PortalLayout } from './PortalLayout';
import { ComplianceDashboard } from './ComplianceDashboard';

export const ProviderCompliancePage = () => (
  <PortalLayout role="provider">
    <ComplianceDashboard />
  </PortalLayout>
);

export const BrokerCompliancePage = () => (
  <PortalLayout role="broker">
    <ComplianceDashboard />
  </PortalLayout>
);

export default ProviderCompliancePage;
